<template>
  <el-dialog :title="sizeForm.id?'编辑消息':'添加消息'" :visible.sync="dialogVisible" v-if="dialogVisible"
             :width="width" top="6vh" modal-append-to-body
             :append-to-body="true">
    <el-form ref="dataForm" :rules="rules" :model="sizeForm" label-width="120px" size="small">

      <!-- 公告标题 -->
      <el-row>
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="sizeForm.title"></el-input>
        </el-form-item>
      </el-row>

      <!-- 类型/通知入口 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="通知类型" prop="type">
              <el-select v-model="sizeForm.type" size="small" filterable clearable placeholder="请选择">
                <el-option v-for="item in dictTypeMap.tmsSendMessageTypeMap" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="通知入口" prop="notificationEntry">
              <el-select v-model="sizeForm.notificationEntry" size="small" filterable clearable placeholder="请选择" :disabled="addOrUpdateCheck" @change="notificationEntrySelect">
                <el-option v-for="item in dictTypeMap.tmsSysAnnouncementNotificationTerminalMap" :key="item.id" :label="item.name" :value="item.id.toString()"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8" v-if="!addOrUpdateCheck">
          <div class="grid-content bg-purple">
            <el-tooltip class="item" effect="dark" content="如未选择人员,则发送当前通知入口的所有人员" placement="top-start">
              <el-form-item label="选择接收人员" prop="selectTheSender">
                <el-button round :disabled="addOrUpdateCheck || !sizeForm.notificationEntry || sizeForm.notificationEntry == 0" @click="notificationEntryPersonnel">+</el-button>
              </el-form-item>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>

      <!-- 已选择发送人员 -->
      <el-row v-if="!addOrUpdateCheck">
        <el-form-item label="已选择发送人员" prop="theSenderHasBeenSelected">
          <el-tag
              style="margin: 5px;"
              v-for="item in selectPersonnel.list"
              :key="item.id"
              type="success"
              closable
              :disable-transitions="false"
              @close="theSenderHasBeenSelectedHandleClose(item)">
            {{ item.name }}
          </el-tag>
        </el-form-item>
      </el-row>

      <!-- 短语 -->
      <el-row>
        <el-form-item label="短语" prop="phrase">
          <el-input v-model="sizeForm.phrase" :rows="2" type="textarea"></el-input>
        </el-form-item>
      </el-row>

      <!-- 公告内容 -->
      <el-row>
        <el-form-item label="消息内容" prop="content">
          <tipTap ref="tipTapRef" v-model="sizeForm.content" :editable="true"/>
        </el-form-item>
      </el-row>

      <!-- 发布时间/结束时间 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="发布时间" prop="publishTime">
              <el-date-picker v-model="sizeForm.publishTime" type="datetime" placeholder="选择日期时间"
                              style="width: 100%;"
                              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker v-model="sizeForm.endTime" type="datetime" placeholder="选择日期时间" style="width: 100%;"
                              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleCancel">取消</el-button>
      <el-button size="mini" :loading="btnLoading" type="primary" @click="handleConfirm">确定</el-button>
    </span>

    <el-dialog title="选择人员" :visible.sync="selectPersonnel.dialogVisible" v-if="selectPersonnel.dialogVisible" :close-on-click-modal="false" width="80%" :append-to-body="true">
      <driverV ref="sendMessageRef" v-if="selectPersonnel.driverVisible" />
      <userV ref="sendMessageRef" v-if="selectPersonnel.userVisible" />
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sendMessageSubmit">确 认</el-button>
      <el-button type="primary" @click="selectPersonnel.dialogVisible = false">返 回</el-button>
    </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import * as myJsonClone from "@/utils/myJsonClone"
import tipTap from '@/components/el-tiptap'
import driverV from "@/views/modules/transport/driver.vue"
import userV from "@/views/modules/sys/user.vue"
const uniqueBy = (arr, prop) => {
  return [...new Map(arr.map(item => [item[prop], item])).values()];
};
export default {
  components: {driverV, userV, Tinymce, tipTap},
  props: {
    width: {
      type: String,
      default: '1000px'
    }
  },
  data() {
    return {
      addOrUpdateCheck: false,
      dialogVisible: false,
      btnLoading: false,
      sizeForm: {
        content: '',
        type: 0,
      },
      rules: {
        phrase: [
          {required: true, message: '请输入公告短语', trigger: 'blur'}
        ],
        title: [
          {required: true, message: '请输入公告标题', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入公告内容', trigger: 'blur'}
        ],
        publishTime: [
          {required: true, message: '请选择发布时间', trigger: 'blur'}
        ],
        endTime: [
          {required: true, message: '请选择发布时间', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择通知类型', trigger: 'blur'}
        ],
        notificationEntry: [
          {required: true, message: '请选择通知入口', trigger: 'blur'}
        ]
      },

      // 选择人员
      selectPersonnel: {
        dialogVisible: false,
        driverVisible: false,
        userVisible: false,
        list: [],
        row: undefined,
      }
    }
  },
  mounted() {
  },
  computed: {
    dictTypeMap: {
      get() {
        return this.$store.state.common.dictTypeMap
      }
    }
  },
  methods: {
    handleCheckChange(data) {
      this.sizeForm.menuIds.push(data.id)
    },
    // 打开弹窗并传入要显示的内容
    openDialog(row) {
      // 重置
      this.addOrUpdateCheck = false
      this.btnLoading = false
      this.sizeForm = this.$options.data().sizeForm
      this.selectPersonnel = this.$options.data().selectPersonnel
      this.addOrUpdateCheck = false
      if (row && row.id) {
        this.addOrUpdateCheck = true
        let cloneRow = myJsonClone.getClone(row)
        this.sizeForm = cloneRow
        this.sizeForm.content = this.formatRichText(cloneRow.content || null)
        this.$forceUpdate()
      } else {
        this.sizeForm = {
          content: ''
        }
      }
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    handleCancel() {
      // 点击取消按钮触发的事件，同样可以向外emit自定义事件，供父组件监听
      this.$emit('cancel')
      this.sizeForm = {
        no: '',
        name: '',
        status: '1',
        maxAdminAccount: 0,
        menuIds: [],
        remark: ''
      }
      this.dialogVisible = false
    },
    // 过滤详情内容
    formatRichText(html) {
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      })
      newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/max-max-width:[^;]+;/gi, 'max-width:100%;')
        return match
      })
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      newContent = newContent.replace(
          /\<img/gi,
          '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      )
      return newContent
    },
    // 表单提交
    handleConfirm() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let cloneSizeForm = myJsonClone.getClone(this.sizeForm);
          if (this.selectPersonnel.list.length > 0) {
            cloneSizeForm.sendIds = this.selectPersonnel.list.map(item => item.id)
          }
          this.btnLoading = true
          this.$http({
            url: this.$http.adornUrl(cloneSizeForm.id ? '/sendMessage/send/update' : '/sendMessage/send/create'),
            method: cloneSizeForm.id ? 'post' : 'put',
            data: this.$http.adornParams({
              ...cloneSizeForm,
              content: this.formatRichText(cloneSizeForm.content),
            })
          }).then((response) => {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.btnLoading = false
              this.handleCancel()
            })
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 通知入口被选择后重置
    notificationEntrySelect(row) {
      if (!this.selectPersonnel.row || this.selectPersonnel.row != row) {
        this.selectPersonnel = this.$options.data().selectPersonnel
        this.selectPersonnel.row = row
      }
    },
    notificationEntryPersonnel() {
      this.selectPersonnel.dialogVisible = true
      this.selectPersonnel.driverVisible = false
      this.selectPersonnel.userVisible = false
      if (this.selectPersonnel.row == '1') {
        this.selectPersonnel.driverVisible = true
        setTimeout(() => {
          this.$refs.sendMessageRef.getDataList(1)
        }, 500)
      } else if (this.selectPersonnel.row == '2') {
        this.selectPersonnel.userVisible = true
        setTimeout(() => {
          this.$refs.sendMessageRef.getDataList()
        }, 500)
      }
    },
    sendMessageSubmit() {
      this.selectPersonnel.list = uniqueBy(this.selectPersonnel.list.concat(this.$refs.sendMessageRef.getSelectionChangeHandle()),'id');
      this.selectPersonnel.dialogVisible = false
    },
    theSenderHasBeenSelectedHandleClose(item) {
      this.selectPersonnel.list.splice(this.selectPersonnel.list.indexOf(item), 1);
    }
  }
}
</script>

<style scoped lang="less">
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-dialog__body {
  padding: 20px !important;
}

.lableNone {
  ::v-deep .el-form-item__label {
    display: none;
  }
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  ::v-deep .el-button--mini {
    padding: 5px 10px;
  }
}
</style>
